import { useEffect } from 'react';
import i18n from './../../../i18n';
import EditableForm from './../../components/BackgroundInfo/EditableForm';
import layoutStyles from './../../components/common/Layout.module.scss';
import PageHeading from './../../components/PageHeading/PageHeading';
import {
  AnalyticsPhaseCategories,
  AnalyticsPhases,
  isLaunchReady,
  trackPhase,
} from '../../../api/analytics-api';
import { Feature } from '../../../types/featureSwitches';
import { getInitialState, isFeatureEnabled } from '../../../utils';
import InsuranceEventsAlert from '../../components/InsuranceEventsAlert';
import RatingLoading from '../RatingLoading';
import { ProfilingResult } from 'dto/ProfilingResult';
import { useAppStore } from 'state/store';

const ANALYTICS_POLLING_INTERVAL_MS = 500;
const ANALYTICS_POLLING_MAX_ATTEMPTS = 20; // 10 seconds total

const BackgroundView = () => {
  const {
    marketableProduct,
    profilingResult,
    hasIncompleteInsuranceEvents,
    authenticatedCustomer,
  } = getInitialState();

  const ratingLoading = useAppStore.use.ratingLoading();

  useEffect(() => {
    const track = () => {
      trackPhase(
        AnalyticsPhaseCategories.START,
        AnalyticsPhases.CALCULATE_PRICE,
        'vakuutukset;henkivakuutus;1;;;eVar66=aikuinen itselle'
      );
    };

    if (isLaunchReady()) {
      track();
      return;
    }

    let attempts = 0;
    const id = setInterval(() => {
      attempts += 1;
      if (isLaunchReady()) {
        track();
        clearInterval(id);
      } else if (attempts >= ANALYTICS_POLLING_MAX_ATTEMPTS) {
        console.warn('Analytics: Adobe Launch not ready after polling timeout');
        clearInterval(id);
      }
    }, ANALYTICS_POLLING_INTERVAL_MS);

    return () => {
      clearInterval(id);
    };
  }, []);

  if (profilingResult === ProfilingResult.BLOCK) {
    return <></>;
  }

  if (!marketableProduct) {
    throw new Error('No marketableProduct found');
  }

  if (ratingLoading) {
    return <RatingLoading />;
  }

  return (
    <>
      <div className={layoutStyles.columnReverse}>
        <PageHeading
          data-cy='calculator-title'
          data-testid='calculator-title'
          title={i18n.t('background.header')}
        />
        {isFeatureEnabled(
          Feature.FEATURE_SHOW_INCOMPLETE_EVENTS_NOTIFICATION
        ) &&
          authenticatedCustomer &&
          hasIncompleteInsuranceEvents && <InsuranceEventsAlert />}
      </div>
      <p>{i18n.t('background.subheader')}</p>
      <p>{i18n.t('background.requiredFieldsNotice')}</p>
      <EditableForm />
    </>
  );
};

export default BackgroundView;
